import {
    makePersistData,
    makeRetrieveData,
    makeDestroyData,
    getStorageEngine,
} from 'common/util/persistent-storage';

const SAVED_AUTH_KEY = 'auth';

const authStorageEngine = getStorageEngine('localStorage');

export const saveAuthCredentials = makePersistData(authStorageEngine, SAVED_AUTH_KEY);
export const getAuthCredentials = makeRetrieveData(authStorageEngine, SAVED_AUTH_KEY);
export const destroyAuthCredentials = makeDestroyData(authStorageEngine, SAVED_AUTH_KEY);
